import { useQuery } from '@tanstack/react-query';
import { IProfessionalCountsResponse } from '../types/IProfessionalCountsResponse';
import { ProfessionalsService } from '../services/ProfessionalsService';
import { factoryGetProfessionalCountsKey } from '../factories/queries/factoryGetProfessionalCountsKey';

const FIVE_MINUTES = 5 * 60 * 1000;

interface IUseGetProfessionalCountsByOfficeOptions {
  enable?: boolean;
  distance?: number;
  state?: string;
}

export const useGetProfessionalCountsByOffice = (
  officeId: string,
  options: IUseGetProfessionalCountsByOfficeOptions = {},
) => {
  const { enable = true, distance, state } = options;

  const { data, isLoading, isFetching, isError } = useQuery<IProfessionalCountsResponse>({
    queryKey: factoryGetProfessionalCountsKey({ officeId, distance, state }),
    queryFn: () =>
      ProfessionalsService.getProfessionalCountsByOffice({ officeId, distance, state }),
    enabled: enable && !!officeId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: FIVE_MINUTES,
  });

  const totalCount = data?.byProfession
    ? Object.values(data.byProfession).reduce((sum, n) => sum + n, 0)
    : 0;

  return {
    totalCount,
    countsByProfession: data?.byProfession,
    isLoading: isLoading || isFetching,
    isError,
  };
};
